import { InspectionStandard } from '@Types';
import React from 'react';
import { StatusTag } from '@innovyze/stylovyze';
import { TFunc } from '@Translations/types';

export const parseQuickRating = (quickRating: string): number => {
	return parseInt(quickRating.match(/^(\d)/)?.[0] ?? '-1');
};

export const ratingCell = (rating: number | string, t: TFunc) => {
	const grade =
		typeof rating === 'number' ? rating : parseQuickRating(rating);
	switch (grade) {
		case 0:
			return <StatusTag text={t('Pristine')} color="neutral" />;
		case 1:
			return <StatusTag text={t('Excellent')} color="negligible" />;
		case 2:
			return <StatusTag text={t('Good')} color="low" />;
		case 3:
			return <StatusTag text={t('Fair')} color="medium" />;
		case 4:
			return <StatusTag text={t('Poor')} color="high" />;
		case 5:
			return <StatusTag text={t('Urgent')} color="extreme" />;
	}
};

export const inspectionStandard = (
	inspectionVersion: string,
): InspectionStandard => {
	if (inspectionVersion.toUpperCase().startsWith('MACP'))
		return InspectionStandard.MACP;
	else if (inspectionVersion.toUpperCase().startsWith('MSCC'))
		return InspectionStandard.MSCC;
	else if (inspectionVersion.toUpperCase().startsWith('WSA05'))
		return InspectionStandard.WSA05;
	else return InspectionStandard.PACP;
};
